var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style['block']},[_c('p',{class:_vm.$style['title'],domProps:{"innerHTML":_vm._s(_vm.$t('moreExclusiveSection.text'))}}),_vm._v(" "),_c('AlButton',{attrs:{"theme":"dark","href":_vm.externalCompareMobileHref,"arrow":""}},[_vm._v("\n    "+_vm._s(_vm.$t('moreExclusiveSection.button'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }